import { IPbrInputProps } from "../PbrInput/PbrInput";
import * as React from "react";
import { PbrInputMask } from "../PbrInput/PbrInputMask";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useState } from "react";

export function PbrInputCpf(
  props: {
    formWrapper: WrappedFormUtils;
    isRequired?: boolean;
    allowCnpj?: boolean;
    requiredMsg?: string;
  } & IPbrInputProps
) {
  const cpfMask = "999.999.999-99";
  const cnpjMask = "99.999.999/9999-99";

  const [allowCnpj] = useState(props.allowCnpj === undefined ? true : props.allowCnpj);
  // const [mask, setMask] = useState(props.value.toString().length <= 15 ? cpfMask : allowCnpj ? cnpjMask : cpfMask);
  const [mask, setMask] = useState(props.value ? (props.value.toString().length <= 15 ? cpfMask : allowCnpj ? cnpjMask : cpfMask) : cpfMask);

  return (
    <PbrInputMask
      type="tel"
      placeholder={"Digite o CPF/CNPJ aqui"}
      name={props.name}
      mask={mask}
      onKeyDown={e => {
        const code = e.nativeEvent.key;
        const target = e.nativeEvent.target as HTMLInputElement;

        if ("1234567890Backspace".indexOf(code) > -1) {
          if (code === "Backspace") {
            if (target.selectionStart === 0) {
              return;
            } else if (target.value.length <= 15) {
              setMask(cpfMask);
            } else if (allowCnpj) {
              setMask(cnpjMask);
            }
          } else if (target.value.length >= 14 && allowCnpj) {
            setMask(cnpjMask);
          } else {
            setMask(cpfMask);
          }
        }
      }}
      maskChar={null}
      rules={[
        {
          required: props.isRequired,
          message: props.requiredMsg || "CPF/CNPJ é obrigatório!"
        },
        {
          validator: (rule, value, callback) => {
            if (value && value !== "___.___.___-__") {
              const cpfCnpjValidator = /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$)/;

              const isCpf = cpfCnpjValidator.exec(value);
              if (isCpf) {
                callback();
              } else {
                callback("CPF/CNPJ inválido.");
              }
            } else {
              callback();
            }
          }
        }
      ]}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputCpf/PbrInputCpf.tsx